import { lazy, Suspense } from "react";
import type { Region } from "@/types/billing";

const BelowFoldSections = lazy(() => import("./below-fold-sections"));

export function LazyBelowFold({ region }: { region: Region }) {
  return (
    <Suspense fallback={<BelowFoldSkeleton />}>
      <BelowFoldSections region={region} />
    </Suspense>
  );
}

function BelowFoldSkeleton() {
  return (
    <div className="space-y-8 animate-pulse">
      <div className="h-96 bg-muted/20 rounded-xl" />
      <div className="h-64 bg-muted/20 rounded-xl" />
      <div className="h-48 bg-muted/20 rounded-xl" />
    </div>
  );
}
